import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const NotFound = ()=> import('@/pages/Page404')
const Validate = ()=> import('@/views/Validate')

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/',
    name: 'Escritorio',
    component: TheContainer, // montar componente
    children: [
      {
        path: '/',
        name: 'Inicio',
        component: Dashboard
      },      
    ]
  },
  {
    path: '/validate/16c3f090-e4d8-11ef-8243-0d1298a8ddb4',
    redirect: '/validate/16c3f090-e4d8-11ef-8243-0d1298a8ddb4',
    name: 'Validar',
    component: TheContainer, // montar componente
    children: [
      {
        path: '/',
        name: 'Inicio',
        component: Validate
      },      
    ]
  },
  { path: '*', component: NotFound }
];

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
});

// router.beforeEach((to, from, next) => {
//   if(store.getters.get__token != null){
//     next()
//     return;
//   }else{
//     next('login')
//     return;
//   }
// });

// export default new Router({
//   mode: 'hash', // https://router.vuejs.org/api/#mode
//   linkActiveClass: 'open active',
//   scrollBehavior: () => ({ y: 0 }),
//   routes: routes
// })
export default router;